var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIcon9(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 12,
    height: 12,
    viewBox: "0 0 12 12",
    fill: "none",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_1_2401)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M9.99047 6.49379C9.99047 8.99143 8.24213 10.2402 6.1641 10.9646C6.05528 11.0014 5.93708 10.9997 5.82942 10.9596C3.74639 10.2402 1.99805 8.99143 1.99805 6.49379V2.99711C1.99805 2.86463 2.05068 2.73757 2.14435 2.64389C2.23803 2.55021 2.36509 2.49758 2.49757 2.49758C3.49663 2.49758 4.74544 1.89815 5.61462 1.13887C5.72045 1.04846 5.85507 0.998779 5.99426 0.998779C6.13345 0.998779 6.26807 1.04846 6.3739 1.13887C7.24807 1.90315 8.49189 2.49758 9.49094 2.49758C9.62343 2.49758 9.75048 2.55021 9.84416 2.64389C9.93784 2.73757 9.99047 2.86463 9.99047 2.99711V6.49379Z",
    stroke: "#364153",
    strokeWidth: 0.999053,
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_1_2401"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 11.9886,
    height: 11.9886,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcon9);
export default __webpack_public_path__ + "static/media/icon9.ad3b5a4b8a7682acd640832b3f95d4f1.svg";
export { ForwardRef as ReactComponent };